import React, { Component } from "react";
import api from "../../config/api";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { openSnackComp } from "../../actions";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Button, Typography } from "@material-ui/core";
import { CardDebit } from "../../components/CardDebit";
import LoadingDefault from "../../components/LoadingDefault";
import Snackbar from "../../components/Snackbar";
import ContentNotLoaded from "../../components/ContentNotLoaded";
import { errorDefault } from "../../helper/errorDefault";
import { convertDebitsData } from "../../helper/convertDebitsData";
import { b64toBlob } from "../../helper/convertBase64toBlob";
import FindDAMHeader from "./FindDAMHeader";

const styles = (theme) => ({
  container: {
    padding: "0px 30px 20px 30px",
    marginTop: "130px",
  },
  menuGroup: {
    display: "flex",
    width: "100%",
    marginTop: "10px",
    marginBottom: "30px",
    padding: "20px 0px 0px 0px",
  },
  centerDiv: {
    width: "100%",
    textAlign: "center",
  },
  linkGroup: {
    textDecoration: "none",
  },
  button: {
    color: "rgb(24, 116, 185)",
    fontSize: 17,
    background: "none",
    border: "none",
    boxShadow: "none",
  },
  loadingDiv: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  marginBottom: {
    marginBottom: 40,
  },
  findBox: {
    width: "100%",
  },
  inputsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "end",
  },
  textFieldParent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "-2px 4px 5px 0px rgba(0, 0, 0, 0.1)",
    padding: "0 0 0px 10px",
    height: 62,
    background: "#fff",
  },
  findIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#1874b9",
    color: "#fff",
    height: "100%",
    width: "60px",
    cursor: "pointer",
  },
  printReportText: {
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    color: "#1874B9",
    marginBottom: 10,
    transition: "all .2s",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  debitsTitle: {
    marginTop: "1.2em",
    marginLeft: "1.2em",
  },
});

export class FindDAM extends Component {
  constructor(props) {
    super(props);

    this.state = {
      findDAM: false,
      debits: [],
      damNumber: "",
      activeButton: false,
      loadingDebits: false,
      loadingDAM: false,
      errorDAM: false,
      errorReport: false,
      errorMessage: "",
      errorLoadDebits: false,
      returnUrl: "/",
      message: "",
    };
  }

  componentDidMount() {
    if (
      this.props.location?.aboutProps !== undefined &&
      this.props.location?.aboutProps !== null
    ) {
      this.setState(
        {
          damNumber: this.props.location?.aboutProps.DAMValue,
          returnUrl: this.props.location?.aboutProps.returnUrl,
        },
        () => {
          this.getDAMs();
        }
      );
    }
  }

  getDAMs = async () => {
    const { damNumber } = this.state;
    if (damNumber === "") {
      this.setState(
        {
          message: "Digite o número do DAM.",
          debits: [],
          errorDAM: false,
          errorLoadDebits: false,
        },
        () => {
          this.props.openSnackComp(true);
        }
      );
    } else {
      this.setState({
        loadingDebits: true,
        errorLoadDebits: false,
        errorDAM: false,
        damInfo: {},
      });

      try {
        const damResponse = await api.get(
          "Debitos/ConsultarDAM?numeroDam=" + damNumber
        );
        let debitsList = [];

        if (damResponse.data.Retorno !== null) {
          this.setState({ damInfo: damResponse.data.Retorno });
          this.setState({
            docContribuinte: damResponse.data.Retorno.Inscricao,
            tipoInscricao: damResponse.data.Retorno.TipoInscricao,
          });
          if (damResponse.data.Retorno.Debitos.length > 0) {
            debitsList = damResponse.data.Retorno.Debitos;
            debitsList.forEach((item) => {
              convertDebitsData(item);
            });

            this.setState({ activeButton: true });
          }

          this.setState({
            debits: debitsList.length > 0 ? debitsList : [],
            findDAM: true,
            errorLoadDebits: false,
            loadingDebits: false,
          });
        } else if (damResponse.data.EhValida === false) {
          let errorMessage =
            damResponse.data.Erros.length > 0 && damResponse.data.Erros[0];
          this.setState(
            {
              message: errorMessage,
              findDAM: true,
              debits: [],
              activeButton: false,
              errorLoadDebits: false,
              loadingDebits: false,
            },
            () => {
              this.props.openSnackComp(true);
            }
          );
        }
      } catch (error) {
        let errorMessage = errorDefault(error);

        this.setState(
          {
            message: errorMessage,
            findDAM: true,
            activeButton: false,
            errorLoadDebits: true,
            loadingDebits: false,
          },
          () => {
            this.props.openSnackComp(true);
          }
        );
      }
    }
  };

  getDAMTyped = (dam) => {
    this.setState({
      damNumber: dam,
      findDAM: false,
      activeButton: false,
      loadingDebits: false,
      errorDAM: false,
      errorLoadDebits: false,
    });
  };

  handlePrintReport = async () => {
    const { damNumber, activeButton } = this.state;

    if (!activeButton) {
      this.setState(
        {
          message: "Busque por algum DAM utilizando o campo de busca.",
        },
        () => {
          this.props.openSnackComp(true);
        }
      );
    } else {
      this.setState({
        loadingDAM: true,
        errorReport: false,
      });

      try {
        const DAMResponse = await api.post(
          "Debitos/GerarRelatorioDAM?nuDam=" +
            damNumber +
            "&tipoInscricao=" +
            this.state.tipoInscricao +
            "&numeroInscricao=" +
            this.state.docContribuinte
        );
        let pdf = "";

        if (DAMResponse.data !== null && DAMResponse.data !== undefined) {
          pdf = DAMResponse.data;

          this.setState({
            loadingDAM: false,
            errorReport: false,
          });

          var file = b64toBlob(pdf, "application/pdf");
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL, "EPrescription");
        }

        if (DAMResponse.data === null || DAMResponse.data === "") {
          this.setState({
            loadingDAM: false,
            errorReport: true,
          });
        }
      } catch (error) {
        this.setState({
          loadingDAM: false,
          errorReport: true,
        });
      }
    }
  };

  handleReissue = async () => {
    const { damNumber, activeButton } = this.state;

    if (!activeButton) {
      this.setState(
        {
          message: "Busque por algum DAM utilizando o campo de busca.",
        },
        () => {
          this.props.openSnackComp(true);
        }
      );
    } else {
      this.setState({
        loadingDAM: true,
        errorDAM: false,
      });

      try {
        const DAMResponse = await api.post(
          "Debitos/GerarSegundaViaDAM?numeroDam=" +
            damNumber +
            "&tipoInscricao=" +
            this.state.tipoInscricao +
            "&numeroInscricao=" +
            this.state.docContribuinte
        );
        let pdf = "";

        if (DAMResponse.data !== null && DAMResponse.data !== undefined) {
          pdf = DAMResponse.data.Retorno;

          this.setState({
            loadingDAM: false,
            errorDAM: false,
          });

          var file = b64toBlob(pdf, "application/pdf");

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file, "DAMPagueFacil.pdf");
          } else {
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "_blank");
          }
        }

        if (DAMResponse.data === null || DAMResponse.data === "") {
          this.setState({
            loadingDAM: false,
            errorDAM: true,
          });
        }
      } catch (error) {
        this.setState({
          loadingDAM: false,
          errorDAM: true,
        });
      }
    }
  };

  render() {
    const { classes } = this.props;
    const {
      debits,
      findDAM,
      loadingDebits,
      loadingDAM,
      errorLoadDebits,
      errorDAM,
      errorReport,
      errorMessage,
    } = this.state;

    return (
      <div>
        <Snackbar message={this.state.message} />

        <Grid
          container
          className={
            this.props.typeFatherApresentation !== "TABS" && classes.container
          }
        >
          {this.props.typeFatherApresentation !== "TABS" && (
            <div className={classes.menuGroup}>
              <Button
                variant="contained"
                className={classes.button}
                onClick={() => this.props.history.goBack()}
              >
                <span>{"<"} VOLTAR</span>
              </Button>
            </div>
          )}
          <div className={classes.findBox}>
            <FindDAMHeader
              isFindDAMPage={this.props.location?.aboutProps}
              getDAMTyped={this.getDAMTyped}
              getDAMs={this.getDAMs}
              handleReissue={this.handleReissue}
              handlePrintReport={this.handlePrintReport}
              infoDAM={this.state.damInfo}
              isLoading={loadingDebits || loadingDAM}
            />

            {findDAM &&
              debits.length === 0 &&
              !loadingDebits &&
              !errorLoadDebits && (
                <ContentNotLoaded message={"DAM não encontrado."} />
              )}

            {findDAM && errorLoadDebits && (
              <ContentNotLoaded
                message={
                  errorMessage ||
                  "Ocorreu um erro no processamento da sua requisição. Tente novamente."
                }
              />
            )}

            {(loadingDebits || loadingDAM) && errorMessage === null && (
              <div className={classes.loadingDiv}>
                <LoadingDefault typeLoading={"card"} />
              </div>
            )}

            {errorDAM && (
              <div className={classes.loadingDiv}>
                <ContentNotLoaded
                  message={"Erro na geração da sua segunda via do DAM."}
                />
              </div>
            )}

            {errorReport && (
              <div className={classes.loadingDiv}>
                <ContentNotLoaded
                  message={"Erro na geração do relatório do DAM."}
                />
              </div>
            )}

            {debits.length > 0 && !errorLoadDebits && (
              <div style={{ width: "100%" }} className={classes.marginBottom}>
                <Typography
                  variant="h6"
                  color="textSecondary"
                  className={classes.debitsTitle}
                >
                  LISTA DE DÉBITOS
                </Typography>
                <Grid container>
                  {debits.length > 0 &&
                    debits.map((item) => {
                      return (
                        <CardDebit
                          key={item.IdDebito}
                          classes={classes}
                          handleGetCardSelected={this.handleGetCardSelected}
                          isFindDAMPage={this.props.location?.aboutProps}
                          contentCard={item}
                          typeCard={"dam"}
                        />
                      );
                    })}
                </Grid>
              </div>
            )}
          </div>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  openModalDebit: store.cardDebitState.openModalDebitValue,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ openSnackComp }, dispatch);

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(FindDAM)
);
